import React from 'react';
import { Button } from '../ui/button';
import { Download, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

const CTA = () => {
  return (
    <section className="py-24 bg-slate-900/30 relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-sky-500/5 to-transparent" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-gradient-to-r from-sky-500/10 to-amber-500/10 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="bg-slate-900/70 border border-slate-800 rounded-3xl p-8 md:p-16 relative overflow-hidden">
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-sky-500/10 to-transparent rounded-full blur-2xl" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-gradient-to-tr from-amber-500/10 to-transparent rounded-full blur-2xl" />

          <div className="relative text-center">
            {/* Icon */}
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-sky-500/20 to-amber-500/20 mb-8">
              <Sparkles className="w-8 h-8 text-amber-400" />
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
              Ready to Stop Tab-Hopping?
            </h2>
            <p className="text-xl text-slate-400 max-w-2xl mx-auto mb-10">
              Download LoadSurf AI now. Your loadboard credentials stay on your machine, 
              encrypted and secure.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button
                size="lg"
                className="bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold px-10 py-7 text-lg group"
                asChild
              >
                <Link to="/download">
                  <Download className="mr-2 w-5 h-5" />
                  Download Now
                </Link>
              </Button>
              <span className="text-slate-500">or</span>
              <Button
                size="lg"
                variant="ghost"
                className="text-slate-300 hover:text-white hover:bg-slate-800 px-10 py-7 text-lg"
                asChild
              >
                <a href="https://app.bubba.ai" target="_blank" rel="noopener noreferrer">
                  Register Now
                </a>
              </Button>
            </div>

            <p className="text-sm text-slate-500 mt-8">
              Available for Windows & Mac
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
